// extracted by mini-css-extract-plugin
module.exports = {"content":"OrderSelector_content__23u3g","submitBtn":"OrderSelector_submitBtn__2kSV3"};